import React from "react";
import Routes from "./Routes";
import {AppContext, ColorModeContext, useColorModeContext} from "./lib/contextLib";
import {Authenticator} from '@aws-amplify/ui-react';
import {Link as RouterLink, BrowserRouter as Router} from "react-router-dom";
import {AppBar, Button, CssBaseline, Grid, Link, Toolbar, Typography, useMediaQuery} from "@mui/material";
import ErrorBoundary from "./components/ErrorBoundary";
import IconButton from "@mui/material/IconButton";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import {createTheme, ThemeProvider, useTheme} from "@mui/material/styles";
import '@aws-amplify/ui-react/styles.css';

export default function ToggleColorMode() {
    const preferredMode = useMediaQuery('(prefers-color-scheme: dark)') ? 'dark' : 'light';
    const [mode, setMode] = React.useState(preferredMode);
    const colorMode = React.useMemo(
        () => ({
            toggleColorMode: () => {
                setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
            },
        }),
        [],
    );

    const theme = React.useMemo(
        () =>
            createTheme({
                palette: {
                    mode,
                },
            }),
        [mode],
    );

    return (
        <ColorModeContext.Provider value={colorMode}>
            <ThemeProvider theme={theme}>
                <CssBaseline/>
                <Authenticator loginMechanisms={["email"]}>
                    {({signOut, user}) => (
                        <Router>
                            <App cognito={{signOut, user}}/>
                        </Router>)
                    }
                </Authenticator>
            </ThemeProvider>
        </ColorModeContext.Provider>
    );
}

const App = (props) => {

    const {signOut, user} = props.cognito;
    const theme = useTheme();
    const colorMode = useColorModeContext();

    return (
        <>
            <header>
                <AppBar position={"static"}>
                    <Toolbar>
                        <Grid container
                              alignItems={"center"}
                              justifyContent={"flex-start"}
                              spacing={1}
                        >
                            <Grid item>
                                <img src={"/favicon-32x32.png"} alt={"key-favicon"}/>
                            </Grid>
                            <Grid item>
                                <Link to={"/"} style={{textDecoration: "none"}} component={RouterLink}>
                                    <Typography color={"textPrimary"} variant={"h6"}>HQS</Typography>
                                </Link>
                            </Grid>
                        </Grid>
                        <Grid container justifyContent={"flex-end"} alignItems={"center"} spacing={1}>
                            <Grid item>
                                <IconButton sx={{ml: 1}} onClick={colorMode.toggleColorMode} color="inherit">
                                    {theme.palette.mode === 'dark' ? <Brightness7Icon/> : <Brightness4Icon/>}
                                </IconButton>
                            </Grid>
                            <Grid item>
                                <Link to={"/settings"} style={{textDecoration: "none"}}
                                      component={RouterLink}>
                                    <Typography color={"textPrimary"}>Settings</Typography>
                                </Link></Grid>
                            <Grid item>
                                <Button onClick={signOut}
                                        style={{textDecoration: "none", textTransform: "none"}}><Typography
                                    color={"textPrimary"}>Logout</Typography></Button></Grid>
                        </Grid>
                    </Toolbar>
                </AppBar>
            </header>
            <ErrorBoundary>
                <AppContext.Provider value={{user}}>
                    <Routes/>
                </AppContext.Provider>
            </ErrorBoundary>
        </>
    );
}
